import axiosInstance from './axiosInstance';

import type { Response } from './axiosInstance'
import { jobEnity } from './job';



export const getJupyterJob = async (): Promise<Response<jobEnity> | undefined> => {
    try {
        const response = await axiosInstance.get<Response<jobEnity>>('/jupyter/', {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return response.data;
    } catch (e) {
        return undefined;
    }
};

type JupyterJob = {
    cpuCores: string
    node: string
    state: number
    timeLimit: number
    timeStart: number
    url: string
}

export const getJupyterJobById = async (jobId: number): Promise<Response<JupyterJob> | undefined> => {
    try {
        const response = await axiosInstance.get<Response<JupyterJob>>(`/jupyter/route`, {
            params: {
                jobId
            },
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return response.data;
    } catch (e) {
        return undefined;
    }
};

export const launchJupyterJob = async (params: { cpu: number, gpu: number, partition?: string, node?: string, maxTime?: number }): Promise<Response<undefined> | undefined> => {
    try {
        const response = await axiosInstance.get<Response<undefined>>('/jupyter/launch', {
            params: {
                cpuNum: params.cpu,
                gpuNum: params.gpu,
                partition: params.partition,
                node: params.node,
                max_time: params.maxTime
            },
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return response.data;
    } catch (e) {
        return undefined;
    }
};